<template>
  <v-btn rounded x-large class="v-button-secondary white text-center green--text"
         v-on="$listeners"
         min-width="185">
    <span class="icon">
      <slot name="icon"></slot>
    </span>
    <span class="label">
      <slot name="text"></slot>
    </span>
  </v-btn>
</template>

<script>
export default {
  name: "ButtonSecondary"
}
</script>

<style scoped lang="scss">
.v-button-secondary {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);
  color: map-get($green, 'base');
  letter-spacing: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: map-get($green, 'base') !important;
    color: $white !important;

    &::before {
      opacity: 0 !important;
    }
  }

  .label {
    padding-bottom: 2px;
  }
}
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-button-secondary {
  // Icon spacing
  .icon {
    margin-right: 8px;

    a {
      transition: all 0.2s ease-in-out;
    }
  }
}
</style>
